module.exports = __webpack_public_path__ + "media/store/images/bx_book-90ab62f3fd8f5bbedf6dd7b338130534.svg";